import React from 'react';
import { Container, Typography } from '@mui/material';

export default function ColumnDesign() {
  return (
    <Container sx={{ mt: 4 }}>
      <Typography variant="h4" gutterBottom>Steel Column Design</Typography>
      <Typography>Module coming soon...</Typography>
    </Container>
  );
} 